/* src/app/otp-page/otp-page.component.scss */
.otpmain-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.popup-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  overflow-y: auto;
}
.popup-content {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
@media (max-width: 640px) {
  .popup-content {
    width: 380px;
  }
}
.description {
  margin-bottom: 25px;
  font-size: 14px;
  color: #6b7280;
}
.top-container {
  padding: 14px;
  border-bottom: 1px solid #E1E4E8;
}
.top-container .ml-4 {
  height: 32px;
}
.input-group label,
.otp-input-container label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  color: #344054;
}
.input-group input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.otp-box-container {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}
::ng-deep .p-inputotp {
  gap: 8px;
}
::ng-deep .p-inputotp .p-inputtext {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  text-align: center;
  font-size: 18px;
  width: 50px;
  height: 50px;
  background-color: #f4f5f7;
  color: #000;
  transition: border-color 0.2s ease-in-out;
}
::ng-deep .p-inputotp .p-inputtext:focus {
  border-color: #e6a447;
  background-color: #ffffff;
  box-shadow: 0 0 4px #e6a447;
}
.button-group {
  margin-top: 15px;
}
.btn-send-otp,
.btn-verify {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  color: black;
  justify-content: center;
}
.btn-send-otp {
  color: black;
  margin-bottom: 10px;
}
.btn-send-otp:disabled,
.btn-verify:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  justify-content: center;
}
.btn-verify {
  color: black;
}
::ng-deep pButton {
  justify-content: center;
}
.resend {
  margin-top: 10px;
  font-size: 14px;
}
.resend a {
  color: #f97316;
  text-decoration: underline;
  cursor: pointer;
}
.phone-input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}
.p-inputtext:focus {
  border-color: #e6a447;
  background-color: #ffffff;
  box-shadow: 0 0 4px #e6a447;
}
.country-code-dropdown {
  padding: 10px;
  font-size: 15px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  width: 100px;
  background-color: #fff;
}
/*# sourceMappingURL=otp-page.component-TXG65TJ6.css.map */
